/**
 * 統一的錯誤類型定義
 */

export interface ApiError {
  isAborted?: boolean;
  status?: number;
  data?: {
    message?: string;
    code?: string;
    error?: {
      data?: {
        details?: {
          message?: string;
        };
      };
    };
    [key: string]: any;
  };
  message?: string;
  [key: string]: any;
}

export interface ErrorMessages {
  [key: number]: string;
}

/**
 * HTTP 狀態碼對應的錯誤訊息
 */
export const HTTP_ERROR_MESSAGES: ErrorMessages = {
  400: "Bad Request：請求格式錯誤，請檢查輸入的資料",
  401: "Unauthorized：未授權，請重新登入",
  403: "Forbidden：權限不足，無法執行此操作",
  404: "Not Found：找不到請求的資源",
  408: "Request Timeout：請求逾時，請重新再試",
  409: "Conflict：資料衝突，請確認後再試",
  422: "Unprocessable Entity：資料驗證失敗，請檢查輸入的資料",
  429: "Too Many Requests：請求過於頻繁，請稍候再試",
  500: "Internal Server Error：伺服器發生錯誤，請稍候再試",
  502: "Bad Gateway：伺服器連線異常，請稍候再試",
  503: "Service Unavailable：服務暫時無法使用，請稍候再試",
  504: "Gateway Timeout：伺服器回應逾時，請稍候再試",
};

/**
 * 網路錯誤訊息
 */
export const NETWORK_ERROR_MESSAGE = "網路連線異常，請檢查網路連線後再試";

/**
 * 預設錯誤訊息
 */
export const DEFAULT_ERROR_MESSAGE = "發生未知錯誤，請稍候再試";

